"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordingEventTypes = void 0;
var RecordingEventTypes;
(function (RecordingEventTypes) {
    RecordingEventTypes["RECORDING_SESSION_ADDED"] = "RECORDING_SESSION/ADDED";
    RecordingEventTypes["RECORDING_SESSION_DELETED"] = "RECORDING_SESSION/DELETED";
    RecordingEventTypes["RECORDING_SESSION_MODIFIED"] = "RECORDING_SESSION/MODIFIED";
    RecordingEventTypes["RECORDING_SEALING_ADDED"] = "RECORDING_SEALING/ADDED";
    RecordingEventTypes["RECORDING_SEALING_DELETED"] = "RECORDING_SEALING/DELETED";
    RecordingEventTypes["RECORDING_SEALING_MODIFIED"] = "RECORDING_SEALING/MODIFIED";
    RecordingEventTypes["RECORDING_SEALING_STARTED"] = "RECORDING_SEALING/STARTED";
    RecordingEventTypes["RECORDING_SEALING_STOPPED"] = "RECORDING_SEALING/STOPPED";
})(RecordingEventTypes || (exports.RecordingEventTypes = RecordingEventTypes = {}));
